import { request } from './request'
// 各个课程类型有效访问数据展示
function selectCourseEffectData(data) {
    return request({
        url: '/sys/orgStat/selectCourseEffectData',
        method: 'POST',
        data: data
    })
}

//获取机构合作与授权资源数据
function selectContractAndCourseData(data) {
    return request({
        url: '/sys/orgStat/selectContractAndCourseData',
        method: 'POST',
        data: data
    })
}

//导出有效访问量数据
function exportOrgSettleRecord(data) {
    return request({
        url: '/sys/orgStat/exportCourseEffectData',
        method: 'POST',
        responseType: 'blob',
        data: data
    })
}

export default {
    selectCourseEffectData,
    selectContractAndCourseData,
    exportOrgSettleRecord
}
